/*
 * @Author: Teemo Ding
 * @Date: 2021-05-26 15:37:29
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-16 15:27:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/SalesChannelCollectionList.tsx
 */
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import ImageCard from '@/src/components/Card/ImageCard';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import NoDataPage from '@/src/components/NoDataPage/NoDataPage';
import NoPermission from '@/src/components/NoPermission';
import {
  deleteCollection,
  getCollectionList,
} from '@/src/request/salesChannel/collection';
import { message } from 'antd';
import React, { Fragment, ReactNode, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Modal } from 'src/components/Antd';
import Query from 'src/constrains/Query/Query';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import {
  breadcrumbData,
  buttonMenu,
  sortList,
} from './SalesChannelCollectionConfig';
import { deleteSearch, searchChange, sortBy } from './slice';

import { useI18n } from 'src/hooks/useRouterChange';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

import css from './css.module.less';
import { SalesChannelModeAccessControlHOC } from '@/src/constrains/SalesChannelModeAccessControl';

const permissions = (saleChannelUuid) => {
  const canViewListing = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProductCollection,
        subCategory: EnumSubCategory.ChannelProductCollection,
        operation: EnumOperation.view_all_collections_listing_page,
      }),
    ],
  });
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProductCollection,
        subCategory: EnumSubCategory.ChannelProductCollection,
        operation: EnumOperation.view_collection_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProductCollection,
        subCategory: EnumSubCategory.ChannelProductCollection,
        operation: EnumOperation.add_edit_product_collection,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProductCollection,
        subCategory: EnumSubCategory.ChannelProductCollection,
        operation: EnumOperation.delete_product_collection,
      }),
    ],
  });
  return { canViewListing, canViewDetails, canCreate, canDelete };
};

const SalesChannelCollectionList = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const state = useSelector((state: any) => state.salesChannelCollectionList);
  const { searchList, sort } = state;
  const [collectionList, setCollectionList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState<string | ReactNode>('');
  const [modalWidth, setModalWidth] = useState<number>(600);
  const [salesChannelName, setSalesChannelName] = useState('');
  const _d = useDispatch();
  const params: any = useParams();
  const history = useHistory();

  const { uuid: salesChannelUuid }: any = params;

  const userPermissions = permissions(salesChannelUuid);

  useEffect(() => {
    fetchData({
      salesChannelUuid: salesChannelUuid,
      searchText: searchList,
      sortBy: sort.data,
    });
  }, [searchList, sort]);
  const addFun = () => {
    history.push(`/salesChannel/collections/editor/${salesChannelUuid}/new`);
  };
  const onSearch = (value) => {
    _d(searchChange(value));
    // getCollectionList({ salesChannelUuid: salesChannelUuid }).then((data) => {
    //   setCollectionList(data);
    // });
  };
  const fetchData = (data) => {
    getCollectionList(data, { salesChannelMultiLanguageRequired: true }).then(
      (data) => {
        setCollectionList(data.summaryList);
        setSalesChannelName(data.salesChannelName);
      },
    );
  };
  const deleteCard = (uuid) => {
    deleteCollection(uuid).then((data) => {
      fetchData({
        salesChannelUuid: salesChannelUuid,
        searchText: searchList,
        sortBy: sort.data,
      });
      setShowModal(false);
      message.success(getI18n('general.deletedsuccessfully'));
    });
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleDuplicate = (uuid) => {
    // duplicateCollection(uuid).then((data) => {
    history.push(
      `/salesChannel/collections/editor/${salesChannelUuid}/${uuid}?type=Duplicate`,
    );
    // });
  };

  const handleDelete = (uuid) => {
    setModalWidth(600);
    setShowModal(true);
    setModalTitle(getI18n('productCollection.index.deleteproductcollection'));
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => deleteCard(uuid)}
        okText={getI18n('general.delete')}
        errorText={getI18n(
          'productCollection.index.deleteproductcollectionerrortext',
        )}
      />,
    );
  };

  const onPress = (value) => {
    _d(searchChange(value));
  };
  const onTagClose = (index) => {
    _d(deleteSearch(index));
  };
  return (
    <Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData(salesChannelName, { getI18n })}
      />
      {(collectionList || {}).length || searchList.length ? (
        <ListPageLayout
          title={getI18n('productCollection.index.productCollection')}
          addText={
            userPermissions.canCreate &&
            getI18n('productCollection.index.createNewCollection')
          }
          addFun={addFun}>
          {userPermissions.canViewListing ? (
            <>
              <Query
                sortBy={state.sort.data}
                sortList={sortList({ getI18n })}
                searchList={searchList}
                onSortClick={(list) => _d(sortBy(list))}
                onSearch={onSearch}
                placeholder={getI18n(
                  'productCollection.index.collectionproductname',
                )}
                state={state}
                filterClassName={css.filterClassName}
                onPress={onPress}
                onTagClose={onTagClose}
              />
              <div className={css.collectionList}>
                {collectionList.map((item) => (
                  <ImageCard
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!userPermissions.canViewDetails) return;
                      history.push(
                        `/salesChannel/collections/editor/${salesChannelUuid}/${item.uuid}`,
                      );
                    }}
                    key={item.uuid}
                    title={item.collectionName}
                    className={css.imageCard}
                    uuid={item.uuid}
                    num={item.salesChannelProductCount}
                    imageUrl={item.imageUrl}
                    overlayMenu={
                      (userPermissions.canCreate ||
                        userPermissions.canDelete) &&
                      buttonMenu(
                        userPermissions.canCreate &&
                          (() => handleDuplicate(item.uuid)),
                        userPermissions.canDelete &&
                          (() => handleDelete(item.uuid)),
                        { getI18n },
                      )
                    }
                  />
                ))}
              </div>
            </>
          ) : (
            <NoPermission />
          )}
        </ListPageLayout>
      ) : userPermissions.canCreate ? (
        <NoDataPage
          title={getI18n('productCollection.index.noDataPageTitle')}
          introduce={getI18n('productCollection.index.noDataPageIntroduce')}
          buttonTitle={getI18n('productCollection.index.createNewCollection')}
          onClick={addFun}
        />
      ) : (
        <NoPermission />
      )}
      <Modal
        width={modalWidth || 600}
        visible={showModal}
        title={modalTitle}
        onCancel={handleCancel}
        maskClosable={false}
        cancelText={getI18n('general.cancel')}>
        {modalContent}
      </Modal>
    </Fragment>
  );
};
export default SalesChannelModeAccessControlHOC(SalesChannelCollectionList);
